import React from 'react';
import ProceduresFormContext from '../../../components/context';
import ProgressBar from './ProgressBar';
import Expand from 'sis_ui/modules/swipe-expand';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import {i18nInit} from 'root/internationalization/config';
const ShowMore = ({expanded}) =>{
    return (
        <div className="evaluation-form-header__show-more-button">
            <FontAwesomeIcon className="animate" icon={expanded ? faChevronUp : faChevronDown} size={"1x"} /> 
            {/* &nbsp;&nbsp;
            {expanded ? 'Less' : 'More'}
            &nbsp;&nbsp;
            <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} size={"1x"} />  */}
        </div>
    )
}

const tagsLabels = {
    // "Activity.Rotation_Program" : "Anesthesiology",
    // "Activity.Event": "Event",
    // "Activity.Event_Type": "Event Type",
    // "Activity.Event_Program": "Event Program",
    // "Activity.Event_Location": "Event Location",
    // "Activity.Event_Date": "Event Date",
    // "Activity.Trigger_Type": "Trigger Type",
    // "Evaluatee.Last_Name" : "Evaluatee",
    // "Evaluatee.First_Name" : "Evaluatee",
    // "Evaluator.Last_Name" : "Evaluator",
    // "Evaluator.First_Name" : "Evaluator",
    // "Epa.Stage" : "Stage",
    // "Epa.Date" : "Date",
     "Epa.Features" : i18nInit.t("lbl.EPA_FEATURES","Features"),
    // "Evaluation.Trigger_Type" : "Trigger Type",
    // "Form.Completion_Status" : "Completion Status",
    // "Form.Tags" : "Tags",
    // "Learner.First_Name" : "Learner",
    // "Learner.Last_Name" : "Learner",
    // "Learner.Tr_Level" : "Learner Training Level",
    // "Learner.Trainee_Program" : "Learner Program",
    // "Presenter.Last_Name" : "Presenter",
    // "Presenter.First_Name": "Presenter",
    // "Presenter.Topic": "Presenter Topic",
    // "Supervisor.Last_Name" : "Supervisor",
    // "Supervisor.First_Name" : "Supervisor",
}
export default class EvaluationFormHeader extends React.Component {
    constructor(props) {
        super(props);

        this.headerRef = React.createRef();
    }

    render() {
        return (
            <ProceduresFormContext.Consumer>
                {({details, placeholders}) => {
                    let filteredPlaceholders = {};
                    if (placeholders) {
                        filteredPlaceholders = Object.keys(tagsLabels).reduce((acc,tag)=>{
                            if (placeholders.hasOwnProperty(tag) && placeholders[tag] != "") {
                                return {
                                    ...acc,
                                    [tag]: placeholders[tag],
                                }
                            }
                            return acc;
                        },{});
                    }
                    if(details != null && placeholders != null){
                        return (
                            <div style={{zIndex:2}}>
                                <Expand 
                                    collapsedHeight={this.props.headerHight}
                                    childRef={this.headerRef}
                                    expandButton={ShowMore}
                                    enabled={Object.keys(filteredPlaceholders).length > 0}
                                    delta={70}
                                >
                                    {({maxHeight}) => {
                                        return (
                                            <div className="evaluation-form-header pt-2" ref={this.headerRef}>
                                            <div className="evaluation-form-header__content col pb-2" style={{height: this.props.headerHight -30}}>
                                                <h3 className="evaluation-form-header__title">{details.NAME}</h3>
                                                <div className="evaluation-form-header__info color-grey"><strong>{details.ACTIVITY}</strong></div>
                                                <div className="evaluation-form-header__info procedure color-grey pb-1"><strong>{details.PROCEDURE_CATEGORY_NAME} - {details.PROCEDURE_NAME}</strong></div>
                                                <div className="evaluation-form-header__info color-grey">{details.EPA_NAME}</div>
                                                <div className="evaluation-form-header__info" dangerouslySetInnerHTML={{ __html: details.EVALUATION_USER}}></div>
                                                <div className="row">
                                                    <span className="col evaluation-card__date color-grey">
                                                        {details.DAYS_TO_EXPIRE ?
                                                            <span>Days to expire: <span className="color-red">{details.DAYS_TO_EXPIRE}</span></span>
                                                        :
                                                            null
                                                        }
                                                        <span className="pull-right">{details.START_DT ? details.START_DT + " / " + details.END_DT : null }</span>
                                                    </span>
                                                </div>
                                            </div>
                                            <ProgressBar/>
                                            <div data-prevent-expand className="evaluation-form-header__extra col pt-2 pb-2" style={{maxHeight: maxHeight - this.props.headerHight }}>
                                                {filteredPlaceholders && Object.keys(tagsLabels).map((tag)=>{
                                                    if (filteredPlaceholders.hasOwnProperty(tag) && filteredPlaceholders[tag] != "") {
                                                        return (
                                                            <div className="evaluation-form-header__extra__row" key={tag}>
                                                                <div className="evaluation-form-header__extra__label color-grey pb-1 pt-1">
                                                                    {tagsLabels[tag]}:
                                                                </div>
                                                                <div 
                                                                    className="evaluation-form-header__extra__field pb-1 pt-1"
                                                                    dangerouslySetInnerHTML={{__html: tag.indexOf("Last_Name") != -1 ? `${filteredPlaceholders[tag]}, ${filteredPlaceholders[tag.replace('Last_Name','First_Name')]}`:filteredPlaceholders[tag]}}
                                                                >
                                                                </div>
                                                            </div>
                                                        )                                                
                                                    }
                                                    
                                                })}
                                            </div>
                                        </div>
                                        )}
                                    }
                                </Expand>
                            </div>
                        )
                    }else{
                        return <div className="evaluation-form-header shadow-depth-1 pt-2">
                            <div className="col">
                                <div className="text-mock bg-primary-placeholder shine"></div>
                                <div className="text-mock bg-primary-placeholder shine"></div>
                                <div className="text-mock bg-primary-placeholder shine"></div>
                                <div className="text-mock__full bg-primary-placeholder shine"></div>
                                <div className="text-mock__full mb-2 bg-primary-placeholder shine"></div>
                            </div>
                        </div>
                    }
                }}
            </ProceduresFormContext.Consumer>
        )
    }
}

